import { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";
import React from "react";
import { cn } from "@/libs/utils";

// loading 보여줄 router path
const includeRoutesPaths = [
  "/tactsuit",
  "/games",
  "/blog",
  "/shop",
  "/do-you-want-include-url",
];
const isShowLoadingRouter = (url: string) =>
  includeRoutesPaths.some((route) => url.startsWith(route));

export const GlobalRouterLoading = () => {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const handleStart = (url: string) => {
      if (!isShowLoadingRouter(url)) return;

      setIsLoading(true);
    };
    const handleComplete = () => {
      setIsLoading(false);
    };

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, [router]);

  return (
    <div
      className={cn(
        "pointer-events-none fixed inset-0 z-[9999] transition-opacity duration-300",
        isLoading ? "opacity-100" : "opacity-0",
      )}
    >
      <div className="fixed left-0 right-0 top-0 z-[10000] h-[2px] overflow-hidden bg-transparent">
        {/* bar */}
        <div className="absolute top-0 h-full animate-loading-bar rounded-full bg-gradient-to-r from-[#FFFBE3] via-[#FFFA7A] to-[#FED600]" />
      </div>
      {/* dim */}
      <div className={cn("absolute inset-0 bg-white/30")} />
    </div>
  );
};
